import { createContext, useState } from 'react';

interface IFields {
  company: boolean;
  email: boolean;
  name: boolean;
}

export interface IContext {
  whatIsComponent: string;
  setComponent: React.Dispatch<React.SetStateAction<string>>;
  fields: {
    company: boolean;
    email: boolean;
    name: boolean;
  };
  setFields: React.Dispatch<React.SetStateAction<IFields>>;
}

export const SimulatorContext = createContext<IContext>({} as any);

export const SimulatorProvider: React.FC = ({ children }) => {
  const [whatIsComponent, setComponent] = useState('register');
  const [fields, setFields] = useState({
    company: false,
    email: false,
    name: false,
  });

  return (
    <SimulatorContext.Provider value={{ setComponent, whatIsComponent, setFields, fields }}>
      {children}
    </SimulatorContext.Provider>
  );
};
